import * as React from "react";
const IncreaseFontSize = ({width, height, color = "#27509B"}, props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 22 22"
    role="img"
    aria-label={"increase fontSize"}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2.66797 6.4165V3.6665H17.3346V6.4165"
      stroke={color}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.25 18.3335H12.75"
      stroke={color}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 3.6665V18.3332"
      stroke={color}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M16 15H19" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M17.5 13.5L17.5 16.5"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default IncreaseFontSize;
